import { Button } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import { pdf } from '@react-pdf/renderer'
import * as FileSaver from 'file-saver'
import { gad7_catalog } from "../../../../escalas/gad7/gad7.catalog"
import Gad7PDF from '../../printed-docs/printed-scales/gad7-pdf'

const gad7_values = [
    "Ningún día",
    "Varios días",
    "Más de la mitad de los días",
    "Casi todos los días"
]

function getGad7Interpretation(score) {
    if (score <= 4) return 'Ansiedad mínima'
    if (score <= 9) return 'Ansiedad leve'
    if (score <= 14) return 'Ansiedad moderada'
    return 'Ansiedad severa'
}

export default function Gad7Results({ gad7, pacienteData, fecha }) {
    if (!gad7) return null

    const score = gad7.reduce((a, v) => a + v, 0)

    const handlePrint = async () => {
        const blob = await pdf(<Gad7PDF pacienteData={pacienteData} fecha={fecha} gad7={gad7} />).toBlob()
        FileSaver.saveAs(blob, `gad7_${pacienteData?.name || 'paciente'}.pdf`)
    }

    return (
        <div>
            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
                <td><strong>Puntuación total: {score} / 21</strong></td>
                <td><strong>{getGad7Interpretation(score)}</strong></td>
            </tr>
            {
                gad7_catalog.map((item, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item}</td>
                        <td>{gad7_values[gad7[index]]}</td>
                    </tr>
                ))
            }
            <div style={{ marginTop: 10, textAlign: 'right' }}>
                <Button icon={<PrinterOutlined />} onClick={handlePrint}>Imprimir escala en pdf</Button>
            </div>
        </div>
    )
}